export default __webpack_public_path__ + "static/media/redo.828f6046.svg";